import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { Eyebrow, Reveal } from "./motion";
import api, { API_BASE } from "@/lib/api";

export default function TestimonialSection() {
    const [items, setItems] = useState(null);

    useEffect(() => {
        api.get("/testimonials")
            .then((r) => setItems(r.data))
            .catch(() => setItems([]));
    }, []);

    if (!items || items.length === 0) return null;

    return (
        <section
            id="testimoni"
            data-testid="testimonial-section"
            className="relative bg-brand-mist/50 py-24 lg:py-32"
        >
            <div className="mx-auto max-w-7xl px-6">
                <Reveal>
                    <Eyebrow>Testimoni</Eyebrow>
                    <h2 className="mt-5 max-w-xl font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
                        Kata mereka tentang DigiKlin.
                    </h2>
                </Reveal>

                <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {items.map((t, i) => (
                        <Reveal key={t.id} delay={(i % 3) * 0.07} className="h-full">
                            <div
                                data-testid={`testimonial-card-${t.id}`}
                                className="flex h-full flex-col rounded-3xl border border-border bg-white p-8 shadow-brand transition-all duration-300 hover:-translate-y-1.5 hover:shadow-brand-lg"
                            >
                                <Quote size={26} className="shrink-0 text-brand-bright" />
                                <p className="mt-4 flex-1 text-sm leading-relaxed text-ink/70">
                                    &ldquo;{t.quote}&rdquo;
                                </p>
                                <div className="mt-6 flex items-center gap-3 border-t border-border pt-5">
                                    {t.photo_path ? (
                                        <img
                                            src={`${API_BASE}/files/${t.photo_path}`}
                                            alt={t.name}
                                            className="h-12 w-12 rounded-full object-cover"
                                            loading="lazy"
                                        />
                                    ) : (
                                        <span className="grid h-12 w-12 place-items-center rounded-full bg-brand font-display text-lg font-bold text-white">
                                            {t.name.charAt(0).toUpperCase()}
                                        </span>
                                    )}
                                    <div>
                                        <p className="text-sm font-bold text-ink">
                                            {t.name}
                                        </p>
                                        <p className="text-xs text-ink/40">
                                            Pelanggan DigiKlin
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
